// react imports
import React, { useState, useRef } from 'react';

const SwitchInput = props => {
  // props
  const {
    name,
    defaultValue,
    checked,
    onChange,
    className = '',
    label,
    ...rest
  } = props;

  // state
  const [isChecked, setIsChecked] = useState(defaultValue || false);

  // ref
  const inputRef = useRef(null);
  const isControlled = checked !== undefined;
  const currentChecked = isControlled ? checked : isChecked;

  // handlers
  const handleChange = event => {
    const newChecked = event.target.checked;

    if (!isControlled) {
      setIsChecked(newChecked);
    }

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={`flex flex-col ${className}`}>
      <div className="mt-1">
        <label className="relative flex flex-col items-start cursor-pointer">
          {/* Visible label text */}
          <span className="mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            {label}
          </span>
          <div className="relative">
            <input
              ref={inputRef}
              type="checkbox"
              name={name}
              checked={currentChecked}
              onChange={handleChange}
              className={`sr-only`}
              {...rest}
            />
            <span
              className={`h-6 w-11 flex items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500 dark:focus:ring-offset-gray-800 ${
                currentChecked
                  ? 'bg-violet-500'
                  : 'bg-gray-200 dark:bg-gray-600'
              }`}
              role="switch"
              aria-checked={currentChecked}
            >
              <span
                className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-200 ease-in-out translate-x-1 ${
                  currentChecked ? 'translate-x-6' : ''
                }`}
              />
            </span>
          </div>
        </label>
      </div>
    </div>
  );
};

export default SwitchInput;
